<template>
    <div>
        <div class="flex text-right mt-5 justify-end space-x-1 items-center">
            <hts-form-button
                v-if="dataCreateQuote.priceOfflineFee.length > 7"
                color="main"
                icon-name="hi-eye-icon"
                icon-position="left"
                type="button"
                icon-style="text-blue-500"
                @click="openViewOfflineFee">
                {{ $t('labels.viewPriceOfflineFee') }}
            </hts-form-button>
            <slot />
        </div>
        <div class="px-32 py-16">
            <table class="w-full table-fixed text-center dark:text-gray-400 border-collapse border border-gray-800">
                <template v-if="dataCreateQuote.transportation === 'CONTAINER'">
                    <tbody>
                        <tr class="bg-blue-300">
                            <td
                                colspan="2"
                                class="border border-gray-800 text-2xl text-left pl-2">
                                <span class="font-bold uppercase">
                                    {{ dataCreateQuote.transportation === 'CONTAINER' ? $t('labels.quoteTowingContainer') : $t('labels.truckPriceQuote') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-2xl text-left pl-2"
                                colspan="3">
                                <span
                                    v-if="dataCreateQuote.code"
                                    class="font-bold">
                                    Quo.No.: {{ dataCreateQuote.code }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td
                                colspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $t('labels.nameCustomer') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="3">
                                <span class="font-bold">
                                    {{ dataCreateQuote.customerName }}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="dataCreateQuote.transportation === 'CONTAINER'">
                            <td
                                colspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.workflow') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="3">
                                <span>
                                    {{ getTextWorkFlow(dataCreateQuote.positions) }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td
                                colspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.route') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="3">
                                <span>
                                    {{ getTextWorkFlow(dataCreateQuote.positions, 'fullNameNode') }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td
                                rowspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <span v-if="dataCreateQuote.transportation === 'CONTAINER'">
                                    {{ $t('labels.containerType') }}
                                </span>
                                <span v-else>
                                    {{ $t('labels.vehicleType') }}
                                </span>
                            </td>
                            <td
                                rowspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <span v-if="dataCreateQuote.transportation === 'CONTAINER'">
                                    {{ listLabelCont[dataCreateQuote.contCategory] || 'unknow' }}
                                </span>
                                <span v-else>
                                    {{ dataCreateQuote.vehicleCategoryName }}
                                </span>
                            </td>
                            <td
                                colspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <div v-if="dataCreateQuote.transportation === 'CONTAINER'">
                                    <span>
                                        {{ $t('labels.mergeContainer') }}
                                    </span>
                                </div>
                                <div v-else>
                                    <span>
&nbsp;
                                    </span>
                                </div>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <div v-if="dataCreateQuote.transportation === 'CONTAINER'">
                                    <span v-if="dataCreateQuote.mergeContainer">
                                        {{ $t('labels.yes1') }}
                                    </span>
                                    <span v-else>
                                        {{ $t('labels.no1') }}
                                    </span>
                                </div>
                                <div v-else>
                                    <span>
&nbsp;
                                    </span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="2">
                                <div v-if="dataCreateQuote.transportation === 'CONTAINER'">
                                    <span>
                                        {{ $t('labels.notRemooc') }}
                                    </span>
                                </div>
                                <div v-else>
                                    <span>
&nbsp;
                                    </span>
                                </div>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <div v-if="dataCreateQuote.transportation === 'CONTAINER'">
                                    <span v-if="dataCreateQuote.headContainer">
                                        {{ $t('labels.yes1') }}
                                    </span>
                                    <span v-else>
                                        {{ $t('labels.no1') }}
                                    </span>
                                </div>
                                <div v-else>
                                    <span>
&nbsp;
                                    </span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.priceTruckingNotVat') }}
                                </span>
                            </td>
                            <td
                                colspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <span>
                                    * {{ $t('labels.max23TonsIncludingContainer') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.VND') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $formatters.formatCurrency(dataCreateQuote.informationEditorPricingSelling.pricingRequest || 0) }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span
                                    v-if="dataCreateQuote.typeReefer === 'REEFER'"
                                    class="text-error-600">
                                    {{ $t('labels.thereIsGenerator') }}
                                </span>
                                <span v-else />
                            </td>
                            <td
                                colspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <span>
                                    * {{ $t('labels.over23TonsIncludingContainer') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.VND') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $formatters.formatCurrency(dataCreateQuote.informationEditorPricingSelling.priceIncrementLevel || 0) }}
                                </span>
                            </td>
                        </tr>
                        <template v-if="dataCreateQuote.priceOfflineFee?.length && dataCreateQuote.priceOfflineFee.length <= 7">
                            <tr
                                v-for="(itemPriceOfflineFee, index) in dataCreateQuote.priceOfflineFee"
                                :key="index">
                                <td
                                    v-if="index === 0"
                                    :rowspan="dataCreateQuote.priceOfflineFee.length"
                                    class="border border-gray-800 text-left pl-2">
                                    <span>
                                        {{ $t('labels.offlineFee') }}
                                    </span>
                                </td>
                                <td
                                    colspan="3"
                                    class="border border-gray-800 text-left pl-2">
                                    <span>
                                        {{ getTextWorkFlow(itemPriceOfflineFee.positions, 'fullNameNode') }}
                                    </span>
                                </td>
                                <td class="border border-gray-800 text-left pl-2">
                                    <span class="font-bold">
                                        {{ $formatters.formatCurrency(itemPriceOfflineFee?.pricingEstimate?.totalOfflineFee) }}
                                    </span>
                                </td>
                            </tr>
                        </template>
                        <tr>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                rowspan="3">
                                <span>
                                    {{ $t('labels.moocSavingPolicy') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.freeHorse') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $formatters.formatCurrency(dataCreateQuote.policy.freeHourNumber) }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                {{ $t('labels.beforeVndHorse') }}
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $formatters.formatCurrency(dataCreateQuote.policy.moocKeepHourly) }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.moocKeepOvernight') }}:
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $formatters.formatCurrency(dataCreateQuote.policy.moocKeepOvernight) || '...' }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="2">
                                <span>
                                    (Tính đến {{ dataCreateQuote.policy.calculatedByHourNextDay || '...' }} hôm sau)
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.moocKeepLongTerm1') }}:
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $formatters.formatCurrency(dataCreateQuote.policy.moocKeepLongTerm) || '...' }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="2">
                                <span>
                                    (Tính đến đêm thứ {{ dataCreateQuote.policy.calculatedFromEvening || '...' }})
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                rowspan="2">
                                <span>
                                    {{ $t('labels.holidaySurchargePolicy') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="3">
                                <span>
                                    {{ $t('labels.towingContainerSunday') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $formatters.formatCurrency(dataCreateQuote.policy.towingContainerSunday) || '...' }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="3">
                                <span>
                                    {{ $t('labels.towingContainerHoliday') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $formatters.formatCurrency(dataCreateQuote.policy.towingContainerHoliday) || '...' }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.reeferPluginCharges') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="3">
                                <span>
                                    {{ $t('labels.reeferPluginChargesGenerator1') }}:
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $formatters.formatCurrency(dataCreateQuote.policy.reeferPluginChargesGenerator) || '...' }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                rowspan="3">
                                <span>
                                    {{ $t('labels.descriptionPriceOlineQuote') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="4">
                                <span>
                                    {{ $t('labels.fromDateQuotation') }}.
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.priceGasOlineMakePricing') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $formatters.formatCurrency(dataCreateQuote?.dataConfig?.priceGasOline) || '...' }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2" />
                            <td class="border border-gray-800 text-left pl-2" />
                        </tr>
                        <tr>
                            <td
                                colspan="4"
                                class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.descriptionPriceOlineQuote1') }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td
                                rowspan="3"
                                class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.contactChanel') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.customerService') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <hts-select-user
                                    v-model="dataCreateQuote.customerService.id"
                                    v-model:name="dataCreateQuote.customerService.name"
                                    prop="customerService.name"
                                    :readonly="onlyView"
                                    required
                                    group-type="customerCare"
                                    placeholder="Tên"
                                    @change="(val) => changeSelectCompanyUser(val, 'customerCare')" />
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="2">
                                <hts-form-input
                                    v-model="dataCreateQuote.customerService.phone"
                                    prop="customerService.phone"
                                    :readonly="onlyView"
                                    group-type="distribution"
                                    placeholder="Số điện thoại" />
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.abstemious') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <hts-select-user
                                    v-model="dataCreateQuote.abstemious.id"
                                    v-model:name="dataCreateQuote.abstemious.name"
                                    :readonly="onlyView"
                                    required
                                    prop="abstemious.name"
                                    placeholder="Tên"
                                    group-type="distribution"
                                    @change="(val) => changeSelectCompanyUser(val, 'distribution')" />
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="2">
                                <hts-form-input
                                    v-model="dataCreateQuote.abstemious.phone"
                                    :readonly="onlyView"
                                    prop="abstemious.phone"
                                    placeholder="Số điện thoại" />
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.groupEmail') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="3">
                                <hts-form-input
                                    v-model="dataCreateQuote.groupEmail"
                                    :readonly="onlyView"
                                    prop="groupEmail" />
                            </td>
                        </tr>
                        <tr>
                            <td
                                rowspan="3"
                                class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.otherNote') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                {{ $t('labels.compensationCost') }}
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <hts-form-input
                                    v-model="dataCreateQuote.compensationCost"
                                    :readonly="onlyView"
                                    type="number"
                                    prop="compensationCost" />
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                {{ $t('labels.notIncluded') }}
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <hts-form-textarea
                                    v-model="dataCreateQuote.exceptCompensationCost"
                                    :readonly="onlyView"
                                    prop="exceptCompensationCost" />
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.vendorPriceModule.effectiveFromDate') }}<span class="text-error-500 ml-1">
                                        *
                                    </span>
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <hts-form-date
                                    v-model="dataCreateQuote.effectiveFromDate"
                                    type="date"
                                    required
                                    :readonly="onlyView"
                                    prop="effectiveFromDate"
                                    name="vendorPriceModule.effectiveFromDate" />
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                {{ $t('labels.effectiveToDateDescriptionQuote') }}
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <hts-form-date
                                    v-model="dataCreateQuote.effectiveToDate"
                                    type="date"
                                    prop="effectiveToDate"
                                    :readonly="onlyView"
                                    name="vendorPriceModule.effectiveToDate" />
                            </td>
                        </tr>
                        <tr>
                            <td
                                colspan="4"
                                class="border border-gray-800 text-left pl-2">
                                <span>
                                    Để thuận tiện, lịch kéo container cần được báo trước 48 tiếng.
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </template>
                <template v-else>
                    <tbody>
                        <tr class="bg-blue-300">
                            <td
                                colspan="2"
                                class="border border-gray-800 text-2xl text-left pl-2">
                                <span class="font-bold uppercase">
                                    {{ $t('labels.truckPriceQuote') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-2xl text-left pl-2"
                                colspan="3">
                                <span
                                    v-if="dataCreateQuote.code"
                                    class="font-bold">
                                    Quo.No.: {{ dataCreateQuote.code }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td
                                colspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $t('labels.nameCustomer') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="3">
                                <span class="font-bold">
                                    {{ dataCreateQuote.customerName }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td
                                colspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.route') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="3">
                                <span>
                                    {{ getTextWorkFlow(dataCreateQuote.positions, 'fullNameNode') }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.vehicleType') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ dataCreateQuote.vehicleCategoryName }}
                                </span>
                            </td>
                            <td
                                colspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <div>
                                    <span>
                                        {{ $t('labels.projectedVolume') }}
                                    </span>
                                </div>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $formatters.formatCurrency(dataCreateQuote.weightCommodity) + 'kg/chuyến' }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.priceTruckingNotVat1') }}
                                </span>
                            </td>
                            <td
                                colspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <span class="text-error-600 font-bold">
                                    <type-commodity-name :data-create-quote="dataCreateQuote" />
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.VND') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $formatters.formatCurrency(dataCreateQuote.informationEditorPricingSelling.pricingRequest || 0) }}
                                </span>
                            </td>
                        </tr>
                        <template v-if="dataCreateQuote.priceOfflineFee?.length && dataCreateQuote.priceOfflineFee.length <= 7">
                            <tr
                                v-for="(itemPriceOfflineFee, index) in dataCreateQuote.priceOfflineFee"
                                :key="index">
                                <td
                                    v-if="index === 0"
                                    :rowspan="dataCreateQuote.priceOfflineFee.length"
                                    class="border border-gray-800 text-left pl-2">
                                    <span>
                                        {{ $t('labels.offlineFee') }}
                                    </span>
                                </td>
                                <td
                                    colspan="3"
                                    class="border border-gray-800 text-left pl-2">
                                    <span>
                                        {{ getTextWorkFlow(itemPriceOfflineFee.positions, 'fullNameNode') }}
                                    </span>
                                </td>
                                <td class="border border-gray-800 text-left pl-2">
                                    <span class="font-bold">
                                        {{ $formatters.formatCurrency(itemPriceOfflineFee?.pricingEstimate?.totalOfflineFee) }}
                                    </span>
                                </td>
                            </tr>
                        </template>
                        <tr>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                rowspan="3">
                                <span>
                                    {{ $t('labels.descriptionPriceOlineQuote') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="4">
                                <span>
                                    {{ $t('labels.fromDateQuotation') }}.
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td
                                colspan="2"
                                class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.priceGasOlineMakePricing') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    VND/lít
                                </span>
                            </td>

                            <td class="border border-gray-800 text-left pl-2">
                                <span class="font-bold">
                                    {{ $formatters.formatCurrency(dataCreateQuote.dataConfig.priceGasOline) || '...' }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td
                                colspan="4"
                                class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.descriptionPriceOlineQuote1') }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td
                                rowspan="3"
                                class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.contactChanel') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.customerService') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <hts-select-user
                                    v-model="dataCreateQuote.customerService.id"
                                    v-model:name="dataCreateQuote.customerService.name"
                                    prop="customerService.name"
                                    :readonly="onlyView"
                                    required
                                    group-type="customerCare"
                                    placeholder="Tên"
                                    @change="(val) => changeSelectCompanyUser(val, 'customerCare')" />
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="2">
                                <hts-form-input
                                    v-model="dataCreateQuote.customerService.phone"
                                    prop="customerService.phone"
                                    :readonly="onlyView"
                                    group-type="distribution"
                                    placeholder="Số điện thoại" />
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.abstemious') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <hts-select-user
                                    v-model="dataCreateQuote.abstemious.id"
                                    v-model:name="dataCreateQuote.abstemious.name"
                                    :readonly="onlyView"
                                    required
                                    prop="abstemious.name"
                                    placeholder="Tên"
                                    group-type="distribution"
                                    @change="(val) => changeSelectCompanyUser(val, 'distribution')" />
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="2">
                                <hts-form-input
                                    v-model="dataCreateQuote.abstemious.phone"
                                    :readonly="onlyView"
                                    prop="abstemious.phone"
                                    placeholder="Số điện thoại" />
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.groupEmail') }}
                                </span>
                            </td>
                            <td
                                class="border border-gray-800 text-left pl-2"
                                colspan="3">
                                <hts-form-input
                                    v-model="dataCreateQuote.groupEmail"
                                    :readonly="onlyView"
                                    prop="groupEmail" />
                            </td>
                        </tr>
                        <tr>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.otherNote') }}
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <span>
                                    {{ $t('labels.vendorPriceModule.effectiveFromDate') }}<span class="text-error-500 ml-1">
                                        *
                                    </span>
                                </span>
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <hts-form-date
                                    v-model="dataCreateQuote.effectiveFromDate"
                                    type="date"
                                    required
                                    :readonly="onlyView"
                                    prop="effectiveFromDate"
                                    name="vendorPriceModule.effectiveFromDate" />
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                {{ $t('labels.effectiveToDateDescriptionQuote') }}
                            </td>
                            <td class="border border-gray-800 text-left pl-2">
                                <hts-form-date
                                    v-model="dataCreateQuote.effectiveToDate"
                                    type="date"
                                    prop="effectiveToDate"
                                    :readonly="onlyView"
                                    name="vendorPriceModule.effectiveToDate" />
                            </td>
                        </tr>
                    </tbody>
                </template>
            </table>
        </div>
        <view-price-offline-fee
            ref="viewPriceOfflineFee"
            :price-offline-fee="dataCreateQuote.priceOfflineFee" />
    </div>
</template>

<script lang="ts" setup>
import ceil from 'lodash-es/ceil'

import { addQuote } from './ignore/imports/form'
import ViewPriceOfflineFee from './view-offline-fee.vue'
import TypeCommodityName from './type-commodity-name.vue'
import { $lodash } from '#imports'

const { $formatters } = useNuxtApp()
const { $disableReactive } = useNuxtApp()
const viewPriceOfflineFee = ref()

const props = defineProps({
  dataCreateQuote: {
    type: Object as PropType<addQuote>,
    required: true
  },
  onlyView: {
    type: Boolean,
    default: false
  }
})

const openViewOfflineFee = () => {
  viewPriceOfflineFee.value && viewPriceOfflineFee.value.openViewPriceOfflineFee()
}
const { dataCreateQuote, onlyView } = toRefs(props)

const getTextWorkFlow = (positions: Array<{ [key: string]: any }>, key: string = 'nodeTypeName') => {
  if (positions && Array.isArray(positions)) {
    const pluckData = $lodash.map(positions, key)

    return $lodash.join(pluckData, ' >> ')
  }
}

const listLabelCont: { [key: number]: any } = {
  10: $t('labels.vehicleModule.10ft'),
  20: $t('labels.vehicleModule.20ft'),
  40: $t('labels.vehicleModule.40ft'),
  45: $t('labels.vehicleModule.45ft'),
  50: $t('labels.vehicleModule.other')
}

const changeSelectCompanyUser = (items: Array<{ [key: string]: any }>, type: string) => {
  if (type === 'customerCare') {
    if (items.length) {
      dataCreateQuote.value.customerService.phone = items[0].formatContactPhoneNumber
    } else {
      dataCreateQuote.value.customerService.phone = ''
    }
  }
  if (type === 'distribution') {
    if (items.length) {
      dataCreateQuote.value.abstemious.phone = items[0].formatContactPhoneNumber
    } else {
      dataCreateQuote.value.abstemious.phone = ''
    }
  }
}
</script>

<style scoped></style>
